<samweb-loading-indicator
   fxFlexFill
   [showForAllLongRunningContextCategories]="false"
   [longRunningContextCategories]="['DIRECTORY_DETAILS']"
   [runForever]="false"
>
   <div *ngIf="directoryInfo$ | async as directoryInfo; else noEntrySelected" fxLayout="column" fxFill>
      <ng-container [ngTemplateOutlet]="contentMode"></ng-container>
   </div>
</samweb-loading-indicator>

<ng-template #contentMode>
   <div
      fxFlex="0 0 auto"
      fxLayout="column"
      class="content-container sam-margin-left sam-margin-right sam-padding-bottom"
   >
      <div
         fxFlex="1 1 auto"
         class="section-title sam-padding-bottom"
         *samwebVar="callableContent$ | async; let callableContent"
      >
         <div fxLayout="row" *samwebVar="directoryInfo$ | async; let directoryInfo">
            <samweb-avatar
               *ngIf="showAvatar$ | async"
               [dn]="callableContent"
               fxFlex="0 0 60px"
               [showPresenceStatus]="false"
            ></samweb-avatar>
            <div fxLayout="column" fxFlex="1 1 auto">
               <div fxLayout="row" fxFlex="1 1 auto">
                  <div fxFlex="1 1 auto" class="sam-margin-left directory-name" *ngIf="directoryInfo?.orgnam">
                     <div fxLayout="column">
                        <div fxFlex="1 1 auto" style="font-size: 1.17em; font-style: italic">
                           {{ directoryInfo?.orgnam }}
                        </div>
                        <div fxFlex="1 1 auto" class="callable" (click)="callContent(callableContent)">
                           {{ callableContent }}
                        </div>
                     </div>
                  </div>
                  <div fxLayout="row" class="edit-buttons">
                     <div>
                        <button
                           kendoButton
                           [disabled]="!(canMakeCallForNumber$ | async) || callableContent.trim().length === 0"
                           (click)="callContent(callableContent)"
                        >
                           <fa-icon [icon]="callIcon" [fixedWidth]="true"></fa-icon>
                        </button>
                     </div>
                     <div>
                        <button kendoButton [disabled]="!(emailFeatureEnabled$ | async)" (click)="composeEmail()">
                           <fa-icon [icon]="mailingIcon" [fixedWidth]="true"></fa-icon>
                        </button>
                     </div>
                     <div *samwebVar="selectedDirectoryBrickInstanceId$ | async; let step">
                        <button
                           [disabled]="!directoryInfo"
                           kendoButton
                           kendoTooltip
                           (click)="editEntry(step)"
                           *ngIf="'DirectoryUpdateContact' | isFeatureEnabled$ | async"
                        >
                           <fa-icon [icon]="editIcon" [fixedWidth]="true"></fa-icon>
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>

   <div class="content">
      <div fxLayout="column" style="height: 100%; overflow: auto">
         <div style="height: 100%; padding: 0 1em">
            <ng-container *samwebVar="callableColumns$ | async as callableColumns">
               <div
                  *ngFor="let availableColumn of availableColumns$ | async; let i = index"
                  style="padding-bottom: 0.5em"
               >
                  <div [ngSwitch]="true" *samwebVar="searchableColumns$ | async as searchableColumns">
                     <div *ngSwitchCase="availableColumn.organisationUnitName === 'APPOINTMENTS'">
                        <samweb-appointments
                           [ngStyle]="{ float: (showFieldNames$ | async) ? 'left' : 'none' }"
                           [id]="(directoryInfo$ | async)?.id"
                           [brickInstanceId]="brickInstanceId"
                        ></samweb-appointments>
                        <span
                           *ngIf="showFieldNames$ | async"
                           class="description"
                           fxFlex="1 1 auto"
                           style="margin-left: 0.35em; margin-top: 0.2em"
                        >
                           {{ availableColumn | directoryColumnTitle | async }}
                        </span>
                     </div>
                     <div style="clear: both" *ngSwitchCase="availableColumn.organisationUnitName === 'MOBILE_STATUS'">
                        <samweb-mobile-status
                           [ngStyle]="{ float: (showFieldNames$ | async) ? 'left' : 'none' }"
                           [mobilePresenceId]="(directoryInfo$ | async)?.fldMobile"
                           [fixedWidth]="true"
                        ></samweb-mobile-status>
                        <span *ngIf="showFieldNames$ | async" class="description" style="margin-left: 0.35em">
                           {{ availableColumn | directoryColumnTitle | async }}
                        </span>
                     </div>
                     <div style="clear: both" *ngSwitchCase="availableColumn.organisationUnitName === 'LINE_STATUS'">
                        <samweb-line-status
                           [ngStyle]="{ float: (showFieldNames$ | async) ? 'left' : 'none' }"
                           [tr87Number]="(directoryInfo$ | async)?.tr87Number"
                           [orgnum]="(directoryInfo$ | async)?.orgnum"
                           [fixedWidth]="true"
                        >
                        </samweb-line-status>
                        <span *ngIf="showFieldNames$ | async" class="description">
                           {{ availableColumn | directoryColumnTitle | async }}
                        </span>
                     </div>
                     <div *ngSwitchCase="availableColumn.organisationUnitName === 'PRESENCE_STATUS_NOTE'">
                        <samweb-presence-status-note
                           [ngStyle]="{ float: (showFieldNames$ | async) ? 'left' : 'none' }"
                           [presenceId]="(directoryInfo$ | async)?.ocsId"
                           [presenceTypeValue]="(directoryInfo$ | async)?.presenceType?.value"
                           [fixedWidth]="true"
                        ></samweb-presence-status-note>
                        <span *ngIf="showFieldNames$ | async" class="description" style="margin-left: 0.35em">
                           {{ availableColumn | directoryColumnTitle | async }}
                        </span>
                     </div>
                     <div
                        style="clear: both"
                        *ngSwitchCase="availableColumn.organisationUnitName === 'PRESENCE_STATUS_FORWARD'"
                     >
                        <samweb-presence-status-forward-destination
                           [ngStyle]="{ float: (showFieldNames$ | async) ? 'left' : 'none' }"
                           [presenceId]="(directoryInfo$ | async)?.ocsId"
                           [presenceTypeValue]="(directoryInfo$ | async)?.presenceType?.value"
                           [fixedWidth]="true"
                        >
                        </samweb-presence-status-forward-destination>
                        <span *ngIf="showFieldNames$ | async" class="description" style="margin-left: 0.35em">
                           {{ availableColumn | directoryColumnTitle | async }}
                        </span>
                     </div>
                     <div
                        *ngSwitchCase="availableColumn.organisationUnitName === 'PRESENCE_STATUS'"
                        style="clear: both"
                     >
                        <samweb-presence-status
                           [ngStyle]="{ float: (showFieldNames$ | async) ? 'left' : 'none' }"
                           [presenceId]="(directoryInfo$ | async)?.ocsId"
                           [presenceTypeValue]="(directoryInfo$ | async)?.presenceType?.value"
                           [fixedWidth]="true"
                        ></samweb-presence-status>
                        <span *ngIf="showFieldNames$ | async" class="description" style="margin-left: 0.35em">
                           {{ availableColumn | directoryColumnTitle | async }}
                        </span>
                     </div>
                     <div *samwebVar="selectedDirectoryBrickInstanceId$ | async; let directoryBrickInstanceId">
                        <div *ngSwitchDefault>
                           <div *samwebVar="directoryInfo$ | async; let directoryInfo">
                              <div>
                                 <fa-icon
                                    (click)="
                                       fireDirectorySearch(availableColumn, directoryInfo, directoryBrickInstanceId)
                                    "
                                    [icon]="availableColumn.columnTyp.columnIcon"
                                    [fixedWidth]="true"
                                    kendoTooltip
                                    [title]="availableColumn | directoryColumnTitle | async"
                                    [ngClass]="{
                                       searchable: searchableColumns.indexOf(availableColumn.directoryColumnKey) > -1
                                    }"
                                 ></fa-icon>
                                 <span
                                    (click)="
                                       callableColumns.indexOf(availableColumn.directoryColumnKey) > -1 &&
                                          call(availableColumn, directoryInfo)
                                    "
                                    [ngClass]="{
                                       callable: callableColumns.indexOf(availableColumn.directoryColumnKey) > -1
                                    }"
                                 >
                                    {{ availableColumn | directoryColumnValue: directoryInfo | async }}
                                 </span>
                                 <span *ngIf="showFieldNames$ | async" class="description">
                                    {{ availableColumn | directoryColumnTitle | async }}
                                 </span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </ng-container>
         </div>
      </div>
   </div>
</ng-template>

<ng-template #noData>
   <div fxFlex="1 1 auto">-</div>
</ng-template>

<ng-template #noEntrySelected>
   <samweb-no-value-selected-info
      [textTranslationKey]="'brick.brick_definitions.directory_details.no_entry_selected'"
      [icon]="noEntrySelectedIcon"
   >
   </samweb-no-value-selected-info>
</ng-template>
